export function isUesLightTheme(path: string) {
  return ['/', '/explorer'].includes(path)
}
